import React, { createContext, useContext } from 'react';
import { DateTimeService } from '../../services';

interface ContextProps {
    dateTimeService: DateTimeService;
}

/*
    Hopefully there is a better way to do this.
    Otherwise TS was yelling
 */
const defaultState = {
    dateTimeService: new DateTimeService(),
};

const DateTimeServiceContext = createContext<ContextProps>(defaultState);

export const DateTimeServiceProvider: React.FC = ({ children }) => {
    const dateTimeService = useProvideDateTimeService();

    return <DateTimeServiceContext.Provider value={dateTimeService}>{children}</DateTimeServiceContext.Provider>;
};

export const useDateTimeService = () => {
    return useContext(DateTimeServiceContext);
};

// Provider hook that creates auth object and handles state
function useProvideDateTimeService() {

    const dateTimeService = new DateTimeService();
    return {
        dateTimeService,
    };
}
